import api from "../../services/api";

const path = "v1/relatorio";

export const reportLiberations = async () => {
  return await api.get(`${path}/liberacaoportal`);
};

export const reportContractProduct = async () => {
  return await api.get(`${path}/contratoproduto`);
};

export const reportMapProduct = async () => {
  return await api.get(`${path}/mapaproduto`);
};

export const reportMapProductMonths = async ({ qtdMeses }) => {
  return await api.get(`${path}/mapacontratomensal?qtdMeses=${qtdMeses}`);
};
